import { cardItems } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-9">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">精选推荐</h2>
          <p className="mt-2 text-sm text-foreground-500">编辑团队为你精选的优质内容，每周更新</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.slice(0, 3).map((item) => (
            <a
              key={item.id}
              href={`#cards`}
              onClick={(e) => e.preventDefault()}
              className="group flex flex-col bg-background-100 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-colors cursor-pointer no-underline"
            >
              <div className="relative overflow-hidden" style={{ aspectRatio: '16/10' }}>
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 text-xs font-medium bg-accent-500 text-background-50 dark:text-foreground-950 rounded-full">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 flex flex-col gap-2 flex-1">
                <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {cardItems.slice(3).map((item) => (
            <a
              key={item.id}
              href={`#cards`}
              onClick={(e) => e.preventDefault()}
              className="group flex flex-col sm:flex-row bg-background-100 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-colors cursor-pointer no-underline"
            >
              <div className="sm:w-48 shrink-0 overflow-hidden" style={{ aspectRatio: '16/10' }}>
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 flex flex-col gap-2 flex-1 justify-center">
                <span className="inline-block self-start px-2 py-0.5 text-xs font-medium bg-secondary-100 text-secondary-700 rounded-full">
                  {item.tag}
                </span>
                <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}